import { ReactComponent as WarningIcon } from "../../assets/icons/warning_yellow.svg";
import warningStyles from "../../styles/UI/warning.module.css";
import labels from "../../utils/labels";

const CitizenAppointmentModifiedBox = () => {
  return (
    <div className={warningStyles.warningBox}>
      <WarningIcon width={14} height={14} />
      <div className="flex gap-[var(--spacing-xs)]">
        <p className={warningStyles.warningBoxTitle}>
          {labels.citizenAppointmentModifiedTitle}
        </p>
        <p className={warningStyles.warningBoxText}>
          {labels.citizenAppointmentModifiedText}
        </p>
      </div>
    </div>
  );
};

export default CitizenAppointmentModifiedBox;
